<script lang="ts">
	import type { CurrentUser } from '$lib/stores/auth-state'
	import Avatar from '$lib/components/profiles/Avatar.svelte'
	import Menu from './Menu.svelte'
	import MenuButton from './MenuButton.svelte'
	import MenuItems from './MenuItems.svelte'
	import MenuTransition from './MenuTransition.svelte'
	import MenuItem from './MenuItem.svelte'
	import LogoutIcon from '$lib/components/icons/LogoutIcon.svelte'

	interface Props {
		class?: string
		user?: CurrentUser | null
		onsignout?: () => void
	}

	let { class: className = '', user = null, onsignout }: Props = $props()

	let avatarSrc = $derived(
		user?.currentProfilePictureUrl && user.currentProfilePictureUrl != ''
			? user.currentProfilePictureUrl
			: '/visuals/icons/default-user.svg',
	)

	function handleSignOut() {
		onsignout?.()
	}

	let name = $derived(user?.currentName || '')
</script>

<Menu class={className}>
	<MenuButton class="flex items-center mx-auto py-4 mb-1">
		<Avatar size="sm" src={avatarSrc} alt={user.currentName} />
	</MenuButton>
	<MenuTransition>
		<MenuItems>
			<div
				class="origin-bottom-right absolute left-0 bottom-full mb-2 w-48 shadow-2xl rounded-md ring-1 ring-black ring-opacity-5 text-black bg-white divide-y divide-gray-200"
			>
				<div class="px-4 py-4 text-center select-none">
					<Avatar size="lg" src={avatarSrc} alt={name} />
					<div class="mt-2 leading-4">{name ?? 'No name'}</div>
					<div class="m-0 mt-1 text-xs leading-4 text-brand-primary truncate text-ellipsis">
						{user.email}
					</div>
				</div>
				<!-- <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
					<MenuItem
						onclick={() => goto('/trips')}
						label="Your Trips"
						class="text-black dark:text-black py-2 px-6"
					>
						<LocationPinIcon class="h-4 w-4 text-black" />
					</MenuItem>
					<MenuItem
						onclick={() => goto('/explore')}
						label="Explore Guides"
						class="text-black dark:text-black py-2 px-6"
					>
						<CompassIcon class="h-4 w-4 text-black" />
					</MenuItem>
					<MenuItem
						onclick={openStore}
						label="Your Store"
						class="text-black dark:text-black py-2 px-6"
					>
						<ShopIcon class="h-4 w-4" />
					</MenuItem>
					<MenuItem
						onclick={openMailer}
						label="Get Help"
						class="text-black dark:text-black py-2 px-6"
					>
						<HelpChatIcon class="h-3 w-3 mx-[2px] text-black" />
					</MenuItem>
				</div> -->
				<div class="py-2">
					<MenuItem
						onclick={handleSignOut}
						label="Log Out"
						class="text-black dark:text-black py-2 px-6"
					>
						<LogoutIcon class="h-4 w-4" />
					</MenuItem>
				</div>
			</div>
		</MenuItems>
	</MenuTransition>
</Menu>
